import React from "react";
import { Button } from "@mui/material/";
import { Download } from "@mui/icons-material";
import { strings } from "../../../../common/i18n";
import { csv } from "../../../../common/lib";
import useAssetData from "./useAssetData";
import { makeStyles } from "@mui/styles";
import styles from "./styles";

type Props = {
    loading: boolean
};

/**
 * Asset Download Button Component
 */
export default () => {
    const { columns, data } = useAssetData();
    const classes = makeStyles(styles)();

    /** Download Asset list  */
    const downloadAssets = () => {
        csv.download(columns, data, `asset-list-summary`);
    };

    return (
        <Button
            className={classes.spacer}
            onClick={downloadAssets}
            size="small"
            color="primary"
            variant="outlined"
        >
            {strings("downloadAssets")}
            <Download />
        </Button>
    );
};
